import { CircularProgress } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import { Observer, observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../sharedComponents/Button';

import { user } from '../../models/User';
import DealerMenuList from './DealerMenuList';
import LogInForm from './LogInForm';
import { AzureAuthenticationContext } from '../../azure/azure-authentication-context';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'contents'
  },

  dialogDiv: {
    height: '100%',
    maxWidth: '450px',
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'hidden'
  },
  dialog: {
    '& > div > div': {
      height: '600px',
      maxHeight: '680px'
    }
  },
  form: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  image: {
    display: 'block',
    margin: `${theme.spacing(5)}px auto`,
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      margin: '10px auto'
    }
  },
  button: {
    padding: '10px',
    marginTop: '10px'
  },
  inline: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  forgotPassword: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em'
    }
  },
  bottomText: {
    fontSize: 'smaller',
    marginTop: 'auto',
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em'
    }
  },
  dealerContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    textAlign: 'center',
    padding: '10px 24px 20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5em',
      padding: '15px 0 0 0'
    }
  },
  loginContent: {
    minWidth: 'calc(100% - 48px)',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 24
  },
  pageOne: {
    translateX: 'translateX(0px)',
    transition: 'transform 500ms ease-in-out'
  },
  pageTwo: {
    transform: 'translateX(calc(-100%))',
    transition: 'transform 500ms ease-in-out'
  },
  arrowButton: {
    padding: '20px',
    width: 'fit-content'
  },
  dealerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 8
  },
  errorMessage: {
    textAlign: 'center',
    margin: 'auto'
  }
}));

const authenticationModule: AzureAuthenticationContext = new AzureAuthenticationContext();

export default observer(() => {
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      user.setEmail('');
    }
  });

  return (
    <Observer
      render={() => (
        <Dialog
          open={user.displayB2CSignInDialog}
          className={classes.dialog}
        >
          <div className={classes.dialogDiv}>
            <DialogContent
              id='dialogFormContentWarper'
              className={clsx(classes.loginContent, {
                [classes.pageOne]: user.displayB2CSignInDialog,
                [classes.pageTwo]: user.displayB2CDealerDialog
              })}
            >
              {user.b2cAuthenticated ? <DialogTitle className={classes.title}>{t('Authenticating User')}</DialogTitle>
                : <div className={classes.root} >
                  <DialogTitle className={classes.title}>{t('Please Sign In to continue')}</DialogTitle>
                  <Button
                   color='secondary'
                   className={classes.button}
                   style={{ marginTop: '40%' }}
                   onClick={() => authenticationModule.login('loginRedirect', user.returnedAccountInfo)}
                   >
                    {t('Sign In')}
                  </Button>
                </div>}
              <div className={classes.root}>
                {user.authenticating ? <CircularProgress style={{ marginLeft: '40%' }} /> : null}
              </div>
              {user.membershipError
                ?
                <div className={classes.root}>
                  <Typography color='error' className={classes.errorMessage}>{user.membershipError}</Typography>
                  <Button color='secondary' className={classes.button} onClick={user.signOut}>
                    {t('Sign Out')}
                  </Button>
                </div>
                : null
              }
            </DialogContent>
            <DialogContent
              id='dialogFormContentWarper'
              className={clsx(classes.loginContent, {
                [classes.pageOne]: user.displayB2CSignInDialog,
                [classes.pageTwo]: user.displayB2CDealerDialog
              })}
            >
              <div className={classes.dealerHeader}>
                <DialogTitle className={classes.title}>{t('Select dealer')}</DialogTitle>
              </div>
              <div>
                <DealerMenuList origin='dialog' />
              </div>
              {user.dealerError
                ?
                <div className={classes.root}>
                  <Typography color='error' className={classes.errorMessage}>{user.dealerError}</Typography>
                  <Button color='secondary' className={classes.button} onClick={user.signOut}>
                    {t('Sign Out')}
                  </Button>
                </div>
                : null
              }
            </DialogContent>
          </div>

        </Dialog>
      )}
    />
  );
});
